export enum ApiTokensActions {
  FetchApiTokens = 'FETCH_API_TOKENS',
  CreateApiToken = 'CREATE_API_TOKEN',
  EditApiToken = 'EDIT_API_TOKEN',
  DeleteApiToken = 'DELETE_API_TOKEN'
}
